import axios from "axios";


export const getAllTaskIncidents = async (companyKey, year) => {
    console.log("getAllTaskIncidents", companyKey, year);
    const response = await axios.get("api/taskincidents?companyid=" + companyKey + "&year=" + year);
    const tasks = response.data;
    return tasks;
}
